// add deep copy of objects
export function deepCopy<T>(source: T): T {
    return JSON.parse(JSON.stringify(source));
}

export function sleep(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
}
